module.exports = __webpack_public_path__ + "images/ranking-events-visibility-drops-88698f5d.svg";